var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"floating-label-input"},[_c('input',{attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_c('span',{staticClass:"floating-label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }